/**
 * Demo mode is disabled. Returns stub values so all consumers work without demo restrictions.
 */
export default function useDemo() {
  return {
    isDemo: false,
    demoFunc: () => {},
    demoShop: null,
    demoAdmin: null,
    demoModerator: null,
    demoMeneger: null,
  };
}
